/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LibraryCategory } from '../models/LibraryCategory';
import type { LibraryItemDtoResponse } from '../models/LibraryItemDtoResponse';
import type { LibraryItemSummaryDtoPaginationResponseResponse } from '../models/LibraryItemSummaryDtoPaginationResponseResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LibraryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param q
     * @param category
     * @param contributor
     * @param sort
     * @param skip
     * @param take
     * @returns LibraryItemSummaryDtoPaginationResponseResponse Success
     * @throws ApiError
     */
    public getApiLibrary(
        q?: string,
        category?: LibraryCategory,
        contributor?: string,
        sort?: string,
        skip?: number,
        take?: number,
    ): CancelablePromise<LibraryItemSummaryDtoPaginationResponseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Library',
            query: {
                'Q': q,
                'Category': category,
                'Contributor': contributor,
                'Sort': sort,
                'Skip': skip,
                'Take': take,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param formData
     * @returns LibraryItemDtoResponse Created
     * @throws ApiError
     */
    public postApiLibrary(
        formData?: {
            Title?: string;
            Summary?: string;
            ContributorInitials?: string;
            ArticleUrl?: string;
            EventDate?: string;
            Category?: LibraryCategory;
            Files?: Array<Blob>;
        },
    ): CancelablePromise<LibraryItemDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/Library',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns LibraryItemDtoResponse Success
     * @throws ApiError
     */
    public getApiLibrary1(
        id: string,
    ): CancelablePromise<LibraryItemDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Library/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param formData
     * @returns LibraryItemDtoResponse Success
     * @throws ApiError
     */
    public putApiLibrary(
        id: string,
        formData?: {
            Title?: string;
            Summary?: string;
            ContributorInitials?: string;
            ArticleUrl?: string;
            EventDate?: string;
            Category?: LibraryCategory;
            Files?: Array<Blob>;
        },
    ): CancelablePromise<LibraryItemDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/Library/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteApiLibrary(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Library/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param attachmentKey
     * @returns LibraryItemDtoResponse Success
     * @throws ApiError
     */
    public deleteApiLibraryAttachments(
        id: string,
        attachmentKey: string,
    ): CancelablePromise<LibraryItemDtoResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/Library/{id}/attachments/{attachmentKey}',
            path: {
                'id': id,
                'attachmentKey': attachmentKey,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
